import { render, staticRenderFns } from "./RegisterTracking.vue?vue&type=template&id=d245bba4"
import script from "./RegisterTracking.vue?vue&type=script&lang=js"
export * from "./RegisterTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports